import { isDefinedArray } from "et3-type-guards";
import React from "react";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import ET3PageDiv from "../../core/et3-page-div";
import Et3PageTitle from "../../core/et3-page-title/index";
import Et3Section from "../../core/et3-section";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getApproveRejectStore from "../../stores/approval-reject-store";
import { APPROVAL_FILTERS_SECTION_ID } from "./approve-reject-constants";
import ApproveRejectData from "./approve-reject-data";
import ApproveRejectForm from "./approve-reject-form";

const ApproveReject = withLiteObserverAndTheme(() => {
  const store = getApproveRejectStore();
  const isPoolLoaded = isDefinedArray(store.approvalData.get());
  const filtersSummary = `${store.createdFromType.get().label} · ${
    store.selectedLimit.get().label
  }`;

  React.useEffect(() => {
    getCoreHistoryStore().setPageName("APPROVAL_DATA", "APPROVAL_DATA");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("APPROVAL")}
        subTitle={i18n.get("APPROVE_USER_DATA")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Et3Section
        titleKey={"APPROVE_REJECT_DATA"}
        summary={filtersSummary}
        count={0}
        sectionId={APPROVAL_FILTERS_SECTION_ID}
        defaultOpen={!isPoolLoaded}
      >
        <ApproveRejectForm />
      </Et3Section>
      <Et3Margin top={16} bottom={0} left={0} right={0} />
      <ApproveRejectData />
    </ET3PageDiv>
  );
});
export default ApproveReject;
